import {newRequest} from '@/utils/request'

// 列表
export const list = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/menu/querylist', params)

// 新增
export const add = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/menu/add', params)

// 修改
export const update = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/menu/update', params)

// 详情
export const details = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/menu/query', params)

// 删除
export const Delete = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/menu/delete', params)
